import { render, staticRenderFns } from "./QuantificationContent.vue?vue&type=template&id=7bb741eb&scoped=true"
import script from "./QuantificationContent.vue?vue&type=script&lang=js"
export * from "./QuantificationContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb741eb",
  null
  
)

export default component.exports